import React, { useEffect, useState, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box'
import Avatar from '@mui/material/Avatar'
import Typography from '@mui/material/Typography'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import OnboardingContainer from 'components/smart/onboarding-container/OnboardingContainer'
import rocket_2 from 'pages/onboarding-reset-password/assets/rocket_2.png'
import AdxInput from 'components/custom/AdxInput'
import { useTheme } from '@mui/material/styles'
import AdxEmployeeAvatar, {
  setMaxInSingleLine,
} from 'components/reusable/employeeAvatar/AdxEmployeeAvatar'
import { useQuery } from 'react-query'
import defaultAvatar from 'assets/images/default_company_photo.png'

// API
import { onboardingJobInformation } from 'services/api/authentication'
import AdxButton from 'components/custom/AdxButton'

const OnboardingJobInformation = () => {
  const { componentHeight } = useTheme()
  const navigate = useNavigate()
  const { data: jobInfo } = useQuery('onboardingJobInfo', async () => {
    const { data } = await onboardingJobInformation()
    return data
  })
  const [avatarWidth, setAvatarWidth] = useState()
  const avatarContainer = useRef(null)

  useEffect(() => {
    setAvatarWidth(avatarContainer?.current?.clientWidth)
  }, [jobInfo])

  return (
    <OnboardingContainer
      srcRightPhoto={rocket_2}
      bgColorRight="alternate.main"
      topRightPhoto={'115%'}
      leftRightPhoto={'115%'}
      heightRightPhoto={'125%'}
      transformRightPhoto={`translate(${-100}%, ${-100}%)`}
    >
      <Box
        height={'100%'}
        display="flex"
        justifyContent={{ xs: 'center', lg: 'flex-end' }}
        alignItems={{ xs: 'flex-start', lg: 'center' }}
      >
        <Box
          width={{ xs: '100%', lg: '500px' }}
          height={{ lg: '650px' }}
          mr={{ lg: 7.6875 }}
          p={{ xs: 2 }}
          position={'relative'}
        >
          <Box mb={4}>
            <Typography variant="body2" mb={1} color="alternate.main">
              Step 2
            </Typography>
            <Typography variant="body1" textAlign="justify">
              Job Information
            </Typography>
          </Box>
          <Box
            display="flex"
            flexDirection={{ xs: 'column', lg: 'row' }}
            gap={2}
            justifyContent={{ lg: 'space-between' }}
            alignItems="center"
            mb={2}
          >
            <Avatar
              sx={{ width: 160, height: 160 }}
              src={(jobInfo && jobInfo?.organization_logo_url) || defaultAvatar}
            />
            <Box sx={{ width: '100%' }}>
              <Typography
                variant="body2"
                textAlign={{ xs: 'center', lg: 'justify' }}
                mb={0.5}
                color="light-gray-text.main"
              >
                Company name
              </Typography>
              <Typography
                variant="body1"
                textAlign={{ xs: 'center', lg: 'justify' }}
                mb={2}
                color="dark-text.main"
              >
                {jobInfo && jobInfo.organization_name}
              </Typography>
              <Typography
                variant="body2"
                textAlign={{ xs: 'center', lg: 'justify' }}
                mb={0.5}
                color="light-gray-text.main"
              >
                Primary Address
              </Typography>
              <Typography
                variant="body1"
                textAlign={{ xs: 'center', lg: 'start' }}
                color="dark-text.main"
              >
                {jobInfo && jobInfo.formatted_address}
              </Typography>
            </Box>
          </Box>
          <Box mb={2} ref={avatarContainer}>
            <Typography variant="body2" mb={0.5} color="light-gray-text.main">
              People in your organization
            </Typography>
            <AdxEmployeeAvatar
              variant
              data={[
                ...(jobInfo?.existing_staff || []),
                ...new Array(jobInfo?.staff_remaining_count),
              ]}
              max={
                jobInfo
                  ? setMaxInSingleLine(avatarWidth, true, jobInfo?.existing_staff?.length)
                  : 15
              }
              tooltip
              tooltipMax={jobInfo?.existing_staff?.length}
              noRemainingTooltip
            />
          </Box>
          <AdxInput
            label="Designation"
            sxLabel={{
              color: 'light-gray-text-2.main' /*, fontSize: "30px!important" */,
            }}
            sx={{
              marginBottom: '16px',
            }}
            size="standard"
            placeholder="Designation"
            value={jobInfo && jobInfo.designation}
            disabled
          />
          <Box display="flex" gap={2} mb={4} alignItems="center">
            <AdxInput
              label="Department"
              sxLabel={{
                color: 'light-gray-text-2.main' /*, fontSize: "30px!important" */,
              }}
              size="standard"
              placeholder="Department"
              value={jobInfo && jobInfo.department_name}
              disabled
            />
          </Box>
          <Box
            width={'100%'}
            display="flex"
            gap={2}
            justifyContent="space-between"
            position={{ lg: 'absolute' }}
            bottom={{ lg: 0 }}
            pr={{ lg: 4 }}
          >
            <AdxButton
              variant={'outlined'}
              sx={{ width: componentHeight.standard }}
              onClick={() => navigate('/onboarding-personal-details')}
            >
              <ChevronLeftIcon />
            </AdxButton>
            <AdxButton
              variant={'contained'}
              key={1}
              sx={{ width: '100%' }}
              size={'standard'}
              onClick={() => navigate('/onboarding-contact-details')}
            >
              Next
            </AdxButton>
          </Box>
        </Box>
      </Box>
    </OnboardingContainer>
  )
}

export default OnboardingJobInformation
